import React from 'react';
import OfflineImage from '@/assets/images/common/offline.png';
import { Button } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { BACKGROUND_COLORS, TEXT_COLORS } from '@/common/presentation/constants/colors';
import tid from '@/common/infrastructure/config/tid';

const Offline: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundColor: BACKGROUND_COLORS.CALENDAR_HEADER
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem'
        }}
      >
        <div
          style={{
            width: '200px',
            height: '200px',
            marginBottom: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={OfflineImage}
            alt="Offline illustration"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        </div>

        <h1 style={{ margin: 0, fontSize: '24px', color: TEXT_COLORS.TEXT_PRIMARY }}>You're Offline</h1>

        <p
          style={{
            fontSize: '16px',
            marginTop: '0.3em',
            margin: '1rem 0 2rem',
            color: TEXT_COLORS.MUTED,
            textAlign: 'center',
            maxWidth: '680px',
            lineHeight: 1.5
          }}
        >
          We can't load information because there's no internet connection. Please check your connection and try again.
        </p>

        <div style={{ display: 'flex', gap: '1rem' }}>
          <Button
            onClick={() => {
              alert('Report an issue clicked');
            }}
            variant="outlined"
            {...tid('common:offline:report-issue-button')}
          >
            REPORT AN ISSUE
          </Button>

          <Button
            onClick={() => {
              window.location.reload();
            }}
            variant="contained"
            {...tid('common:offline:retry-connection-button')}
          >
            <ReplayIcon style={{ marginRight: '0.2rem' }} />
            RETRY CONNECTION
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Offline;
